<script>
    import {Row, Col} from 'svelte-chota';
    import {mdiAccount, mdiAccountCircle, mdiChartLine, mdiAppsBox, mdiDns, mdiCloud} from '@mdi/js';
    import ServiceCard from "./ServiceCard.svelte";
    import InfiniteGrid, {
        GridLayout,
        JustifiedLayout,
        SquareLayout,
        FrameLayout,
        PackingLayout
    } from "@egjs/svelte-infinitegrid";

    export let keycloak;
    export let profile;

    const apps = [
        {
            id: 'account',
            argo_deployment: 'keycloak',
            name: 'Account',
            client: 'account',
            role: 'view-profile',
            icon: mdiAccount,
            url: 'https://auth.aur.rocks/realms/kkinc/account/'
        }, {
            id: 'nextcloud',
            argo_deployment: 'nextcloud',
            name: 'Nextcloud',
            client: 'https://nextcloud.aur.rocks/apps/user_saml/saml/metadata',
            icon: mdiCloud,
            url: 'https://nextcloud.aur.rocks/'
        }, {
            id: 'realm-management',
            argo_deployment: 'keycloak',
            name: 'Realm management',
            client: 'realm-management',
            role: 'view-realm',
            icon: mdiAccountCircle,
            url: 'https://auth.aur.rocks/admin/kkinc/console/'
        }, {
            id: 'grafana',
            argo_deployment: 'grafana',
            name: 'Grafana',
            client: 'grafana',
            role: 'viewer',
            icon: mdiChartLine,
            url: 'https://grafana.aur.rocks/'
        }, {
            id: 'argocd',
            argo_deployment: 'argocd',
            name: 'Argo CD',
            client: 'argocd',
            role: 'viewer',
            icon: mdiAppsBox,
            url: 'https://argocd.aur.rocks/'
        }, {
            id: 'powerdns',
            argo_deployment: 'powerdnsadmin',
            name: 'PowerDNS',
            client: 'powerdnsadmin',
            role: 'user',
            icon: mdiDns,
            url: 'https://dns.aur.rocks/'
        }
    ]

    function getAppRoles(app) {
        if (keycloak === undefined) return [];
        const token = keycloak.tokenParsed;
        if (token === undefined) return [];
        const resource_access = token.resource_access;
        if (resource_access === undefined) return [];
        const resource = resource_access[app.client];
        if (resource === undefined) return [];
        return resource.roles.sort() || [];
    }

    function checkAppIsAvailable(app) {
        if (app.role === undefined) return true;
        return getAppRoles(app).indexOf(app.role) >= 0;
    }

    $: apps_available = apps.filter((app) => checkAppIsAvailable(app))
</script>

<style>
    .item {
        width: 330px;
    }
</style>

<GridLayout
        items={apps_available}
        itemBy={app => app.id}
        groupBy={_ => 'services'}
        useFirstRender={true}
        status={null}
        options={{
            transitionDuration: 0.2,
        }}
        layoutOptions={{
            margin: 10, align: 'center',
        }}
        let:item
>
    {#each apps_available as app (app.id)}
        <div class="item">
            <ServiceCard app={app} profile={profile} roles={getAppRoles(app)}/>
        </div>
    {/each}
</GridLayout>

<!--<Row>-->
<!--</Row>-->
